import { render, staticRenderFns } from "./v-remote-select-upgrade.vue?vue&type=template&id=4f69c7b2&scoped=true"
import script from "./v-remote-select-upgrade.vue?vue&type=script&lang=js"
export * from "./v-remote-select-upgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f69c7b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
